<template>
  <div id="content-wrap" class="content-wrapper">
    <section class="content center-block d-flex justify-content-center">
      <div class="about-container">
        <h2 class="text-center">{{ title }}</h2>
        <p class="text-center">{{ content }}</p>

        <div class="col-md-12 col-sm-12 col-xs-12 mb-4">
          <div class="col-md-4 col-sm-12 col-xs-12 text-center">
            <a :href="zalo_link"><img src="../../assets/icon/zalo.png" alt="logo"></a>
          </div>
          <div class="col-md-4 col-sm-12 col-xs-12 text-center">
            <a :href="facebook_page_link"><img src="../../assets/icon/fb-page.png" alt="logo"></a>
          </div>
          <div class="col-md-4 col-sm-12 col-xs-12 text-center">
            <a :href="facebook_messenger_link"><img src="../../assets/icon/fb-mess.png" alt="logo"></a>
          </div>
        </div>
        <p class="text-center">
          hoặc liên hệ:
        </p>
        <h3 class="text-center mt-2">
          {{ phone_number }}
        </h3>
      </div>
    </section>
  </div>
</template>

<script>
import ParamAPI from '../../api/param'
import Utils from '../../common/utils'

export default {
  name: 'CallCenterIntro',
  data () {
    return {
      title: 'TỔNG ĐÀI ITY',
      content: 'ITY - Tổng Đài Telesales Tiết Kiệm Chi Phí, Gọi MIỄN PHÍ không giới hạn với 3 nhà mạng Viẹttel - Mobi - Vina chỉ với đồng giá 499k/tháng/agent',
      zalo_link: 'https://ity.vn/',
      facebook_page_link: 'https://ity.vn/',
      facebook_messenger_link: 'https://ity.vn/',
      phone_number: '1900 099985',
      loading: true,
      filterData: {
        group: 'CALL_CENTER_ABOUT',
        key: '',
        value: ''
      }
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    initData () {
      this.loading = true
      ParamAPI.filter(this.filterData, 0, 10).then(res => {
        this.loading = false
        const items = res.data.data.records
        items.forEach(item => {
          if (item.key === 'CALL_CENTER_ABOUT_ZALO_LINK') {
            this.zalo_link = item.value
          }
          if (item.key === 'CALL_CENTER_ABOUT_FB_PAGE_LINK') {
            this.facebook_page_link = item.value
          }
          if (item.key === 'CALL_CENTER_ABOUT_FB_MSG_LINK') {
            this.facebook_messenger_link = item.value
          }
          if (item.key === 'CALL_CENTER_ABOUT_TITLE') {
            this.title = item.value
          }
          if (item.key === 'CALL_CENTER_ABOUT_CONTENT') {
            this.content = item.value
          }
          if (item.key === 'CALL_CENTER_ABOUT_PHONE_NUMBER') {
            this.phone_number = item.value
          }
        })
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    }
  },
}
</script>

<style scoped lang="scss">
.about-container {
  width: 40%;

  img {
    width: 60px;
    height: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/call_center/CallCenterIntro.vue